import { thanos26GetJson } from "./thanos26Client";

async function getAllTimeSafeMaterialTypes(): Promise<any> {
    return thanos26GetJson("TimeSafe/MaterialTypes");
}

export default { getAllTimeSafeMaterialTypes };
